import { render, staticRenderFns } from "./ColourSelector.vue?vue&type=template&id=6751f953&scoped=true"
import script from "./ColourSelector.vue?vue&type=script&lang=ts"
export * from "./ColourSelector.vue?vue&type=script&lang=ts"
import style0 from "./ColourSelector.vue?vue&type=style&index=0&id=6751f953&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6751f953",
  null
  
)

export default component.exports